import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { MdContactPhone } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
import { BsCopy } from "react-icons/bs";
import transactionData from './transactionDatab.json';
import './TransactionCard.scss';

const TransactionCard = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const { rate, unit, total, payment_service, status, order_id, date_time } = transactionData.transaction;

  // State to manage the countdown timer
  const [timer, setTimer] = useState(300); // 300 seconds for 5 minutes

  useEffect(() => {
    // Decrease timer by one every second
    const interval = setInterval(() => {
      setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
    }, 1000);

    // Clear the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  // Convert the remaining time to MM:SS format
  const formatTime = () => {
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  // Redirect function using useNavigate
  const redirectToCollections = () => {
    navigate('/Collections'); // Use navigate for in-app routing
  };

  return (
    <div className="transaction-card">
      <div className="transaction-header">
        <span className="transaction-rate">{rate} | {unit}</span>
        <span className="transaction-total">{total}</span>
      </div>
      <div className="transaction-status">
        <span className="transaction-amount">111.00 <BsCopy /></span><br />
        <span className="transaction-status-text">{status}</span>
      </div>
      <hr className="divider" />
      <div className="transaction-details">
        <span className="transaction-label">{status}</span>
        <div className="payment-service">
          <MdContactPhone className="icon" />
          <span className="payment-service-text">{payment_service}</span>
        </div>
      </div>
      <hr className="divider" />
      <div className="transaction-info">
        <div className="transaction-labels">
          <span className="label">trading order</span>
          <span className="label">order time</span>
        </div>
        <hr className="sub-divider" />
        <div className="transaction-order">
          <div className="order-id">
            <span className="label">trading order</span>
            <span className="order-id-text">{order_id} <IoCopyOutline className="icon" /></span>
          </div>
          <div className="payment-method-section">
            <MdContactPhone className="payment-icon" />
            <span className="payment-method-text">Alipay</span>
          </div>
        </div>
      </div>
      <div className="transaction-actions">
        <button className="timer-button">
        time left ({formatTime()})
        </button>
        <button className="redirect-button" onClick={redirectToCollections}>
        Immediate payment
        </button>
      </div>
    </div>
  );
};

export default TransactionCard;
